import React, { useState } from "react";
import { Container, Col, Form, Button, Image, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Header from "./header";

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const handleLogin = () => {
    setShowSpinner(true);
    const formData = new URLSearchParams();
    formData.append("username", username);
    formData.append("password", password);
    formData.append("service", "moodle_mobile_app");

    axios
      .post("https://" + process.env.REACT_APP_HOST + "/login/token.php?lang=en_us", formData)
      .then((response) => {
        if (response.data.token) {
          setShowSpinner(false);
          const formData_1 = new URLSearchParams();
          formData_1.append("moodlewssettingfilter", "true");
          formData_1.append("moodlewssettingfileurl", "true");
          formData_1.append("moodlewssettinglang", "en_us");
          formData_1.append("wsfunction", "core_webservice_get_site_info");
          formData_1.append("wstoken", response.data.token);
          localStorage.setItem("tokenData", formData_1);

          axios
            .post(
              "https://" +
                process.env.REACT_APP_HOST +
                "/webservice/rest/server.php?moodlewsrestformat=json&wsfunction=core_webservice_get_site_info",
              formData_1,
            )
            .then((userdata) => {
              axios
                .get(
                  "https://" +
                    process.env.REACT_APP_HOST +
                    "/webservice/rest/server.php?wstoken=" +
                    process.env.REACT_APP_TOKEN +
                    "&wsfunction=local_course_service_ai_data&moodlewsrestformat=json&userid=" +
                    userdata.data.userid,
                )
                .then((response) => {
                  if (
                    response.data.role_id === 2 ||
                    response.data.role_id === 3 ||
                    userdata.data.userissiteadmin ||
                    response.data.role_id === 1
                  ) {
                    localStorage.setItem("login", true);
                    localStorage.setItem("fullname", userdata.data.fullname);
                    localStorage.setItem("userpictureurl", userdata.data.userpictureurl);
                    localStorage.setItem("role_id", response.data.role_id);
                    localStorage.setItem("email", userdata.data.email);
                    localStorage.setItem("admin", userdata.data.userissiteadmin);
                    localStorage.setItem("userid", userdata.data.userid);
                    navigate("/home");
                    toast.info("Logged in successfully");
                  } else {
                    toast.warning("Please login as admin");
                  }
                });
            });
        } else {
          setShowSpinner(false);
          toast.error("Invalid credentials");
        }
      })
      .catch(() => {
        setShowSpinner(false);
        toast.error("Oops, something went wrong..!");
      });
  };

  return (
    <>
      <Header />
      <section className="login-wrapper d-flex align-items-center justify-content-center vh-100">
        <Container className="d-flex justify-content-center align-items-center h-100">
          <Col xs={12} md={8} lg={6} xl={5} className="d-flex justify-content-center">
            <div className="login-block bg-white rounded w-100" style={{ maxWidth: "480px" }}>
              <Form
                onKeyDown={(e) => {
                  if (e.key === "Enter" && username && password && !showSpinner) {
                    e.preventDefault();
                    handleLogin();
                  }
                }}
              >
                <p className="text-start mb-4 fw-semibold fs-1 lh-lg text-dark">Sign In</p>

                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Enter Username"
                    autoComplete="off"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="py-3"
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Control
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="py-3"
                  />
                </Form.Group>

                <Button
                  variant="warning"
                  className="w-100 text-dark fw-bold py-3"
                  onClick={handleLogin}
                  disabled={!username || !password || showSpinner}
                >
                  {showSpinner ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "Sign In"
                  )}
                </Button>
              </Form>

              <div className="d-flex justify-content-between align-items-center mt-3">
                <Button variant="link fw-semibold" className="p-0">
                  Privacy Policy
                </Button>
                <p className="copyright-text mb-0">Copyright © {currentYear}</p>
              </div>
            </div>
          </Col>
        </Container>
      </section>
    </>
  );
};

export default LoginPage;
